export default __webpack_public_path__ + "static/media/medicationDayImageActive.095f689d.svg";